import axios from 'axios';
import Loader from 'react-loader-spinner';
import Gallery from 'react-photo-gallery';
import Carousel, { Modal, ModalGateway } from 'react-images';
import React, { useState, useCallback, useEffect } from 'react';

import Pagination from '../Pagination';

const baseUrl = process.env.REACT_APP_BASE_URL;

const GalleryImages = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [pagination, setPagination] = useState({
    totalPages: null,
    currentPage: null,
    hasPrevPage: null,
    hasNextPage: null,
    nextPage: null,
    prevPage: null,
  });

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const fetchImages = useCallback((page) => {
    setLoading(true);

    axios
      .get(`${baseUrl}/gallery?page=${page}`)
      .then((res) => {
        let imagesArr = [];

        const {
          totalPages,
          page,
          hasPrevPage,
          hasNextPage,
          nextPage,
          prevPage,
          docs = [],
        } = res.data.data;

        setPagination({
          totalPages,
          currentPage: page,
          hasPrevPage,
          hasNextPage,
          nextPage,
          prevPage,
        });

        if (docs.length) {
          docs.forEach((item) => {
            imagesArr = [
              ...imagesArr,
              {
                src: item.image,
                title: item.title,
                width: 4,
                height: 3,
              },
            ];
          });
        }

        setImages(imagesArr);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingError(true);
      });
  }, []);

  useEffect(() => {
    fetchImages(1);
  }, [fetchImages]);

  return (
    <div className="container section-padding">
      {loading ? (
        <div className="result-container">
          <Loader type="Oval" color="#d90404" height={80} width={80} />
        </div>
      ) : loadingError ? (
        <div className="result-container">
          <p>
            Could not fetch featured gallery photos. Refresh or check back
            later.
          </p>
        </div>
      ) : !images.length ? (
        <div className="result-container">
          <p>No gallery photos. Check back later.</p>
        </div>
      ) : (
        <>
          <Gallery photos={images} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen && (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={images.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            )}
          </ModalGateway>
          {pagination.totalPages > 1 && (
            <Pagination
              paginationDetails={pagination}
              fetchMore={fetchImages}
            />
          )}
        </>
      )}
    </div>
  );
};

export default GalleryImages;
